export const IS_REFRESHING = 'clinic/IS_REFRESHING';
export const LIST_VETS_FOR_CLINIC_REQUEST =
  'clinic/LIST_VETS_FOR_CLINIC_REQUEST';
export const LIST_VETS_FOR_CLINIC_SUCCESS =
  'clinic/LIST_VETS_FOR_CLINIC_SUCCESS';

export const SAVE_PRACTICE_TYPE = 'clinic/SAVE_PRACTICE_TYPE';
